module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/coca-cola-b1f1dc6bc965f4a7fe805600d915dd69.png";